module.exports = __webpack_public_path__ + "img/icon39.4fcec2a0.png";